<div
  class="min-h-screen bg-black py-[100px] px-[15px] xl:py-[130px] relative overflow-hidden"
>
  <!-- Background splatter pattern - subtle dark texture -->
  <div
    class="absolute inset-0 opacity-[0.03] pointer-events-none"
    style="
      background-image: radial-gradient(
          circle at 20% 50%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        radial-gradient(
          circle at 80% 80%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        ),
        radial-gradient(
          circle at 40% 20%,
          rgba(255, 255, 255, 0.1) 1px,
          transparent 1px
        );
      background-size: 200px 200px, 300px 300px, 250px 250px;
    "
  ></div>

  <div class="w-[900px] max-w-full mx-auto text-center relative z-10">
    <div class="mx-auto mb-8">
      <h2
        class="text-green-primary text-4xl md:text-5xl font-bold mb-4 transition-all duration-25 overflow-hidden"
        style="animation: abc-text-animation 3s ease-in-out infinite"
      >
        Uh oh!
      </h2>
      <p class="text-xl leading-7 text-white text-center sm:text-lg mb-2">
        This page is not available at ABC Links.
      </p>
      <p class="text-lg leading-6 text-white text-center sm:text-base">
        Click below to navigate to ABC Talkies.
      </p>
    </div>

    <div class="w-[200px] block mx-auto">
      <button
        class="w-full px-6 py-3 bg-green-primary hover:bg-green-dark text-white rounded-md transition-colors font-medium text-lg"
        type="button"
        title="Go to ABC Talkies"
        (click)="routeToHome()"
      >
        Go to ABC Talkies
      </button>
    </div>
  </div>
</div>
